import styled from "styled-components";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";

export const Root = styled.div<{
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
  marginLeft?: number;
  alignRight?: boolean;
  width?: number;
  fullWidth?: boolean;
}>`
  position: relative;
  display: inline-block;

  margin-top: ${(p) => p.marginTop || 0}px;
  margin-right: ${(p) => p.marginRight || 0}px;
  margin-bottom: ${(p) => p.marginBottom || 0}px;
  margin-left: ${(p) => p.marginLeft || 0}px;

  width: ${(p) => (p.width ? p.width + "px" : p.fullWidth ? "100%" : "auto")};

  ${(p) =>
    p.alignRight &&
    `
      margin-left: auto;
      display: block;
    `}
`;

export const StyledButton = styled.button<{
  action?: boolean;
  size?: "small" | "medium" | "large";
  fullWidth?: boolean;
  disabled?: boolean;
}>`
  border-radius: 8px;
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: 1px solid;

  ${(props) => {
    switch (props.size) {
      case "small":
        return `
          padding: 8px 12px;
          font-size: ${FontSize.Standard};
          max-height: 36px;
        `;
      case "large":
        return `
          padding: 16px 18px;
          font-size: ${FontSize.Large};
          max-height: 56px;
        `;
      default:
        return `
          padding: 12px 14px;
          font-size: ${FontSize.Standard};
          max-height: 48px;
        `;
    }
  }}

  width: ${(props) => (props.fullWidth ? "100%" : "auto")};

  ${(props) =>
    props.action
      ? `
    background: #6b7280;
    color: ${Color.White};
    border-color: #6b7280;

    &:hover:not(:disabled) {
      background: #4b5563;
      border-color: #4b5563;
    }

    &:active:not(:disabled) {
      background: #374151;
      border-color: #374151;
    }
  `
      : `
    background: transparent;
    color: #6b7280;
    border-color: #d1d5db;

    &:hover:not(:disabled) {
      background: #f9fafb;
      border-color: #9ca3af;
      color: #4b5563;
    }

    &:active:not(:disabled) {
      background: #f3f4f6;
      border-color: #6b7280;
      color: #374151;
    }
  `}

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:focus:not(:disabled) {
    box-shadow: 0 0 0 2px rgba(107, 114, 128, 0.2);
  }
`;

export const ButtonRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;

export const Caret = styled.span`
  font-size: 12px;
  line-height: 1;
  opacity: 0.9;
`;

export const Dropdown = styled.div<{ width?: number }>`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 1000;

  min-width: ${(p) => (p.width ? `${p.width}px` : "180px")};
  width: max-content;

  background: ${Color.White};
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  padding: 6px;
`;

export const DropdownItem = styled.button<{ disabled?: boolean }>`
  width: 100%;
  border: 0;
  background: transparent;
  text-align: left;

  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 500;
  font-size: ${FontSize.Standard};

  padding: 10px 10px;
  border-radius: 8px;
  cursor: pointer;

  color: ${(p) => (p.disabled ? "#9ca3af" : "#374151")};

  &:hover {
    background: ${(p) => (p.disabled ? "transparent" : "#f3f4f6")};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(107, 114, 128, 0.18);
  }

  ${(p) =>
    p.disabled &&
    `
      cursor: not-allowed;
    `}
`;
